module.exports = __webpack_public_path__ + "img/live2d-download-icon.188c0d00.png";